import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, HeadingVariant, LiliSwitch, Text } from '@lili/lili-frontend-common';
import { Skeleton } from 'primereact/skeleton';
import { ReactComponent as DotIcon } from '../../../assets/icons/svg/shared/ic-shared-dot.svg';

interface BalanceUpDashboardFooterProps {
  balanceUpState: boolean;
  handleOnToggle: () => void;
  limitReached?: boolean;
  isEligible?: boolean;
  isLoading?: boolean;
}

const BalanceUpDashboardFooter = ({
  balanceUpState,
  handleOnToggle,
  limitReached,
  isEligible,
  isLoading,
}: BalanceUpDashboardFooterProps) => {
  const { t } = useTranslation('balanceUpTranslation');

  if (isLoading) {
    return (
      <div className='w-full h-[78px] border-t-[1px] border-outline-primary-bw-03 bg-surface-primary-bw-01'>
        <Skeleton className='w-full h-[78px] !rounded-b-[8px]' height='78px' borderRadius='0px' />
      </div>
    );
  }
  return (
    <div className='w-full px-[24px] h-[78px] pt-[15px] pb-[12px] border-t-[1px] border-outline-primary-bw-03 bg-surface-primary-bw-01 rounded-b-[8px]'>
      <div className='flex flex-row justify-between items-center h-full'>
        <div className='flex flex-col'>
          {!balanceUpState && isEligible && !limitReached && (
            <Text.H9 fontWeight={FontWeight.SEMIBOLD}>{t('DASHBOARD_FOOTER.ACTIVATE')}</Text.H9>
          )}
          <span className='flex flex-row gap-[3px]'>
            <Heading variant={!balanceUpState ? HeadingVariant.H9 : HeadingVariant.H8}>
              {t('DASHBOARD_FOOTER.TITLE')}
            </Heading>
            <Heading
              id='balance-up-opt-in-status'
              variant={!balanceUpState ? HeadingVariant.H9 : HeadingVariant.H8}
              fontWeight={FontWeight.SEMIBOLD}
            >
              {t(balanceUpState ? 'DASHBOARD_FOOTER.ON' : 'DASHBOARD_FOOTER.OFF')}
            </Heading>
            <DotIcon className={`${balanceUpState ? 'text-text-badge-green' : 'text-text-negative-red'}`} />
          </span>
          {!isEligible && (
            <Text.H9 className='text-text-main-secondary'>{t('DASHBOARD.REVOKED_PENDING_RENEWAL')}</Text.H9>
          )}
          {limitReached && isEligible && (
            <Text.H9 className='text-text-main-secondary'>{t('DASHBOARD_FOOTER.LIMIT_REACHED')}</Text.H9>
          )}
        </div>
        {!limitReached && isEligible && (
          <LiliSwitch
            checked={balanceUpState}
            id='balance-up-toggle'
            onChange={() => {
              handleOnToggle();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default BalanceUpDashboardFooter;
